import { ReactNode } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDBadgeDot from "components/MDBadgeDot";

interface BadgeItem {
  color: "primary" | "secondary" | "info" | "success" | "warning" | "error" | "dark";
  size?: "xs" | "sm" | "md" | "lg";
  badgeContent: string;
}

interface Props {
  color?: "primary" | "secondary" | "info" | "success" | "warning" | "error" | "dark";
  icon: ReactNode;
  title: string;
  description?: string;
  value?: string | number;
  badges?: BadgeItem[];
  [key: string]: any;
}

function ColorInfoCard({
  color,
  icon,
  title,
  description,
  value,
  badges = [],
}: Props): JSX.Element {
  return (
    <Card>
      <MDBox p={2}>
        {icon && (
          <MDBox mb={1} display="flex" alignItems="center" gap={0.5}>
            <Icon fontSize="small" color="info">
              {icon}
            </Icon>
            <MDTypography variant="h6" color={color}>
              {title}
            </MDTypography>
          </MDBox>
        )}

        {description && <MDTypography variant="body2">{description}</MDTypography>}
        {value && (
          <MDTypography variant="h5" fontWeight="bold">
            {value}
          </MDTypography>
        )}
      </MDBox>
      <MDBox px={1} pb={1} pt={0}>
        {badges.map((badge, index) => (
          <MDBox
            key={index}
            display="flex"
            alignItems="center"
            gap={0.1}
            sx={{
              lineHeight: 1,
              margin: 0,
              padding: 0,
              height: "25px",
            }}
          >
            <MDBadgeDot color={badge.color} size={badge.size || "sm"} badgeContent="" />
            <MDTypography
              variant="caption"
              color="text"
              sx={{
                fontSize: "1rem",
                whiteSpace: "nowrap",
                maxWidth: "100%",
                display: "block",
                lineHeight: 1,
                padding: 0,
                margin: 0,
              }}
              whiteSpace="nowrap"
            >
              {badge.badgeContent}
            </MDTypography>
          </MDBox>
        ))}
      </MDBox>
    </Card>
  );
}

ColorInfoCard.defaultProps = {
  color: "info",
  value: "",
  description: "",
  badges: [],
};

export default ColorInfoCard;
